var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from '../../styled';
const generateWeight = ({ theme, fontType, weight, lang, }) => {
    let key = weight;
    if (lang !== 'en' && weight === 'Semibold') {
        key = 'Medium';
    }
    return (theme.fonts[fontType].weight[key] || theme.fonts[fontType].weight.Default);
};
const Content = styled.span `
  display: inline-block;
  color: ${({ theme, color }) => (color ? theme.colors[color] : 'inherit')};
  font-size: ${({ theme, fontType, lang }) => {
    const { size } = theme.fonts[fontType];
    return typeof size === 'string' ? size : size[lang];
}};
  font-family: -apple-system, BlinkMacSystemFont, 'Noto Sans', Roboto, Arial;
  font-weight: ${generateWeight};
  line-height: ${({ theme, fontType, lang }) => theme.fonts[fontType].lineHeight[lang]};
`;
const Text = (_a) => {
    var { children, color, fontType = 'DisplayLarge', weight = 'Default', lang, e2eId } = _a, restProps = __rest(_a, ["children", "color", "fontType", "weight", "lang", "e2eId"]);
    return (React.createElement(Content, Object.assign({}, restProps, { color: color, fontType: fontType, weight: weight, lang: lang, "data-e2e-id": e2eId }), children));
};
export default Text;
//# sourceMappingURL=index.js.map